import { ScanLine, Radio } from "lucide-react";
import { C, RED } from "../../theme/tokens";
import { formatHistoryTimestamp } from "../../utils/time";

/* One row in the signal-history list: source-bot icon, asset and a
   SIGNALS/SCANNER badge on the left, win/loss result on the right.
   Win keeps the app's sage accent; loss reuses the same functional
   red used for down candles elsewhere, rather than introducing a
   third accent color. */
export function SignalHistoryRow({ item, t, lang }) {
  const isWin = item.profit === true;
  const isScanner = item.source === "SCANNER";
  const SourceIcon = isScanner ? ScanLine : Radio;
  const sourceLabel = item.source;
  const { time, dayLabel } = formatHistoryTimestamp(item.created_at, lang);
  const dayText = dayLabel === "today" ? t.prof_today : dayLabel === "yesterday" ? t.prof_yesterday : dayLabel;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        background: C.panel1,
        border: `1px solid ${C.hairline}`,
        borderRadius: 14,
        padding: "12px 14px",
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          borderRadius: 10,
          background: C.deep,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <SourceIcon size={16} color="#ffffff" />
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 7, flexWrap: "wrap" }}>
          <span
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 700,
              fontSize: 13.5,
              color: C.primary,
            }}
          >
            {item.asset}
          </span>
          <span
            style={{
              fontSize: 10.5,
              fontWeight: 600,
              color: C.secondary,
              background: C.panel2,
              borderRadius: 20,
              padding: "2px 8px",
              letterSpacing: "0.02em",
            }}
          >
            {sourceLabel}
          </span>
        </div>
        <div style={{ fontSize: 11.5, color: C.mutedB, marginTop: 3 }}>
          {dayText} · {time}
        </div>
      </div>

      <div style={{ textAlign: "right", flexShrink: 0 }}>
        <div
          style={{
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: "0.04em",
            color: isWin ? C.greenLight : RED,
          }}
        >
          {isWin ? t.prof_result_win : t.prof_result_loss}
        </div>
      </div>
    </div>
  );
}